import { getMultipleCTATemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const multipleCTAConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Two button CTA",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
        {
          type: "selectbox",
          name: "form",
          label: "Button style",
          items: [
            { value: "rounded", text: "Rounded" },
            { value: "squared", text: "Squared" },
          ],
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Button color",
        },
        {
          type: "colorinput",
          name: "borderColor",
          label: "Border color",
        },
      ],
    },
    initialData: {
      bgColor: "#30c632",
      borderColor: "#2bab2e",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getMultipleCTATemplate({
        url: data.url,
        form: data.form,
        bgColor: data.bgColor,
        borderColor: data.borderColor,
        tab: data.openLink,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { multipleCTAConfig };
